import { render } from "./Contratacao.vue?vue&type=template&id=e8fa6732&scoped=true&ts=true"
import script from "./Contratacao.vue?vue&type=script&lang=ts"
export * from "./Contratacao.vue?vue&type=script&lang=ts"

import "./Contratacao.vue?vue&type=style&index=0&id=e8fa6732&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8fa6732"]])

export default __exports__